import React from 'react';
import BaseGridToolbar from '../shared/toolbar/BaseGridToolbar';

const TransactionListToolbar = ({ columns, data, type = 'sales', ...props }) => {
  return (
    <BaseGridToolbar
      title={type === 'sales' ? 'Sales' : 'Purchases'}
      columns={columns}
      data={data}
      {...props}
    />
  );
};

export default React.memo(TransactionListToolbar);
